import { render, staticRenderFns } from "./StockEmail.vue?vue&type=template&id=94665672&"
import script from "./StockEmail.vue?vue&type=script&lang=js&"
export * from "./StockEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94665672')) {
      api.createRecord('94665672', component.options)
    } else {
      api.reload('94665672', component.options)
    }
    module.hot.accept("./StockEmail.vue?vue&type=template&id=94665672&", function () {
      api.rerender('94665672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/StockEmail.vue"
export default component.exports